import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { CheckCircle2, MapPin, Briefcase, GraduationCap, Users, TrendingUp, Award, Upload, Building2, Sparkles, Heart } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
import { saveSubmission, type FormateurSubmission } from '../services/databaseService';
export function FormateursPage() {
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData(e.target as HTMLFormElement);
    const data = Object.fromEntries(formData.entries()) as Record<string, string>;
    // Sauvegarder dans la base de données locale
    saveSubmission<FormateurSubmission>({
      type: 'formateur',
      nom: data.nom || '',
      prenom: data.prenom || '',
      email: data.email || '',
      telephone: data.telephone || '',
      domaine: data.domaine || '',
      experience: data.experience || '',
      disponibilite: data.disponibilite || ''
    });
    // Envoyer via Web3Forms (email à contact@adcc.africa)
    const result = await sendViaWeb3Forms({
      type: 'formateur',
      fields: data
    });
    console.log('📋 Formateur submission result:', result);
    setIsLoading(false);
    setSubmitted(true);
    window.scrollTo(0, 0);
  };
  // --- 9. CONFIRMATION ---
  if (submitted) {
    return <Layout data-id="element-979">
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4 py-12" data-id="element-980">
          <Card className="max-w-md w-full text-center p-10 shadow-lg border-t-4 border-t-[#1E88E5]" data-id="element-981">
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-982">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-983" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-984">
              Candidature envoyée !
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-985">
              Merci pour votre intérêt. Notre équipe pédagogique va étudier
              votre profil et vous recontactera très prochainement pour un
              premier échange.
            </p>
            <Button onClick={() => window.location.reload()} className="w-full text-lg py-6" data-id="element-986">
              Fermer
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-987">
      <SEO {...pageSEO.formateurs} data-id="element-988" />

      {/* BLOC 1 — HERO */}
      <section className="bg-[#2C3E50] text-white py-20 md:py-28" data-id="element-989">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-990">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-6" data-id="element-991">
            Rejoindre l'équipe pédagogique
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-992">
            Devenez Formateur ADCC
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-993">
            Partagez votre expertise, formez la prochaine génération de
            professionnels et contribuez à l'insertion digne au Bénin.
          </p>
          <div className="flex justify-center" data-id="element-994">
            <Button size="lg" className="text-lg px-8 py-6 shadow-lg hover:scale-105 transition-transform" onClick={() => {
            document.getElementById('postuler')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-995">
              Postuler maintenant
            </Button>
          </div>
        </div>
      </section>

      {/* BLOC 2 — DOMAINES D'EXPERTISE */}
      <section className="py-20 bg-white" data-id="element-996">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-997">
          <div className="text-center mb-16" data-id="element-998">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-999">
              Domaines d'expertise recherchés
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1000">
              Vous êtes professionnel·le expérimenté·e et souhaitez transmettre
              vos compétences ?
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1001">
            {[{
            icon: Building2,
            title: 'Hôtellerie & Restauration'
          }, {
            icon: Sparkles,
            title: 'Nettoyage & Hygiène'
          }, {
            icon: Heart,
            title: 'Services à la personne'
          }, {
            icon: Briefcase,
            title: 'Insertion professionnelle'
          }, {
            icon: GraduationCap,
            title: "Formation d'adultes"
          }, {
            icon: Users,
            title: 'Métiers du care'
          }].map((domain, index) => <Card key={index} className="border-none shadow-md hover:shadow-xl transition-all duration-300 group" data-id="element-1002">
                <CardContent className="p-8 text-center" data-id="element-1003">
                  <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-1004">
                    <domain.icon className="w-8 h-8 text-[#1E88E5]" data-id="element-1005" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-1006">
                    {domain.title}
                  </h3>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* BLOC 3 — AVANTAGES */}
      <section className="py-20 bg-gray-50" data-id="element-1007">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1008">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1009">
            <div data-id="element-1010">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1011">
                Ce que vous gagnez
              </h2>
              <p className="text-xl text-gray-600 mb-10" data-id="element-1012">
                Rejoindre l'ADCC, c'est bien plus qu'une mission ponctuelle.
              </p>

              <div className="space-y-6" data-id="element-1013">
                {[{
                icon: Award,
                title: 'Formation gratuite',
                desc: "Bénéficiez d'une formation de formateur certifiante sans frais."
              }, {
                icon: Briefcase,
                title: 'Missions rémunérées',
                desc: 'Accédez à des opportunités de missions rémunérées régulières.'
              }, {
                icon: TrendingUp,
                title: 'Revenus complémentaires',
                desc: 'Valorisez votre expertise pour générer un revenu additionnel.'
              }, {
                icon: Heart,
                title: 'Impact social',
                desc: "Contribuez concrètement à l'insertion professionnelle au Bénin."
              }, {
                icon: Users,
                title: 'Réseau professionnel',
                desc: "Intégrez une communauté d'experts et de partenaires engagés."
              }].map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-1014">
                    <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center flex-shrink-0" data-id="element-1015">
                      <benefit.icon className="w-6 h-6 text-[#1E88E5]" data-id="element-1016" />
                    </div>
                    <div data-id="element-1017">
                      <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-1018">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed" data-id="element-1019">
                        {benefit.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="relative" data-id="element-1020">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#1E88E5]/20 to-transparent rounded-3xl transform translate-x-6 translate-y-6" data-id="element-1021"></div>
              <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&q=80&w=800" alt="Formateur ADCC en action" className="relative rounded-3xl shadow-2xl w-full object-cover h-[600px]" data-id="element-1022" />
            </div>
          </div>
        </div>
      </section>

      {/* BLOC 4 — PRÉREQUIS */}
      <section className="py-20 bg-white" data-id="element-1023">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1024">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1025">Prérequis</h2>
          <p className="text-xl text-gray-600 mb-12" data-id="element-1026">
            Pour garantir la qualité de nos formations, nous recherchons des
            profils répondant à ces critères :
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-1027">
            {["Minimum 3 ans d'expérience pratique dans votre domaine d'expertise.", 'Excellentes capacités de communication et sens de la pédagogie.', "Adhésion aux valeurs de l'ADCC (dignité, respect, bienveillance).", 'Disponibilité ponctuelle demandée selon les sessions de formation.'].map((req, index) => <div key={index} className="flex items-start gap-4 bg-gray-50 p-6 rounded-xl" data-id="element-1028">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-1029" />
                <p className="text-gray-700 font-medium" data-id="element-1030">{req}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* BLOC 5 — FORMULAIRE */}
      <section id="postuler" className="py-20 bg-gray-50" data-id="element-1031">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1032">
          <Card className="shadow-xl border-t-4 border-t-[#1E88E5]" data-id="element-1033">
            <CardContent className="p-8 md:p-12" data-id="element-1034">
              <div className="text-center mb-10" data-id="element-1035">
                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1036">
                  Postuler maintenant
                </h2>
                <p className="text-gray-600" data-id="element-1037">
                  Remplissez ce formulaire pour rejoindre notre vivier de
                  formateurs.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-8" data-id="element-1038">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1039">
                  {/* Nom */}
                  <div className="space-y-2" data-id="element-1040">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1041">
                      Nom *
                    </label>
                    <input type="text" name="nom" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="Votre nom" data-id="element-1042" />
                  </div>

                  {/* Prénom */}
                  <div className="space-y-2" data-id="element-1043">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1044">
                      Prénom *
                    </label>
                    <input type="text" name="prenom" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="Votre prénom" data-id="element-1045" />
                  </div>

                  {/* Email */}
                  <div className="space-y-2" data-id="element-1046">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1047">
                      Email *
                    </label>
                    <input type="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="votre@email.com" data-id="element-1048" />
                  </div>

                  {/* Téléphone */}
                  <div className="space-y-2" data-id="element-1049">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1050">
                      Téléphone *
                    </label>
                    <input type="tel" name="telephone" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="+229..." data-id="element-1051" />
                  </div>

                  {/* Domaine d'expertise */}
                  <div className="space-y-2 md:col-span-2" data-id="element-1052">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1053">
                      Domaine d'expertise principal *
                    </label>
                    <select name="domaine" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white" data-id="element-1054">
                      <option value="" data-id="element-1055">Sélectionnez votre domaine...</option>
                      <option value="hotellerie" data-id="element-1056">
                        Hôtellerie / Restauration
                      </option>
                      <option value="nettoyage" data-id="element-1057">Nettoyage / Hygiène</option>
                      <option value="care" data-id="element-1058">
                        Services à la personne / Nounou
                      </option>
                      <option value="autre" data-id="element-1059">Autre</option>
                    </select>
                  </div>

                  {/* Expérience */}
                  <div className="space-y-2" data-id="element-1060">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1061">
                      Années d'expérience *
                    </label>
                    <select name="experience" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white" data-id="element-1062">
                      <option value="" data-id="element-1063">Sélectionnez...</option>
                      <option value="1-3" data-id="element-1064">1 à 3 ans</option>
                      <option value="3-5" data-id="element-1065">3 à 5 ans</option>
                      <option value="5-10" data-id="element-1066">5 à 10 ans</option>
                      <option value="10+" data-id="element-1067">Plus de 10 ans</option>
                    </select>
                  </div>

                  {/* Disponibilité */}
                  <div className="space-y-2" data-id="element-1068">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1069">
                      Disponibilité *
                    </label>
                    <select name="disponibilite" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white" data-id="element-1070">
                      <option value="" data-id="element-1071">Vos disponibilités ?</option>
                      <option value="ponctuelle" data-id="element-1072">
                        Ponctuelle (quelques jours/mois)
                      </option>
                      <option value="weekends" data-id="element-1073">Week-ends uniquement</option>
                      <option value="flexible" data-id="element-1074">Flexible</option>
                    </select>
                  </div>

                  {/* CV / Lien LinkedIn */}
                  <div className="space-y-2 md:col-span-2" data-id="element-1075">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1076">
                      CV (Lien ou description de votre parcours) *
                    </label>
                    <textarea name="cv" required rows={4} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="Lien vers votre profil LinkedIn, ou décrivez brièvement votre parcours professionnel..." data-id="element-1077"></textarea>
                  </div>
                </div>

                <Button type="submit" className="w-full text-lg py-6 shadow-lg" disabled={isLoading} data-id="element-1078">
                  {isLoading ? 'Envoi en cours...' : 'Envoyer ma candidature'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>;
}